import { ADD_BENEFIT_PRO } from '@gql/benefits';
import { FormControl, FormLabel } from '@mui/material';
import * as React from 'react';
import { Controller } from 'react-hook-form';

import { AutoCompleteField } from './AutoCompleteField';
import { NestedSubOption, Props } from './types';
import { flatten } from './utils';


export function AutocompleteWowEffect({
    control,
    name,
    label,
    placeholder,
    disabled,
    options,
    groupedOptions,
    ...props
}: Props) {
    const _options = React.useMemo(() => {
        return (groupedOptions ? flatten(groupedOptions) : options) || [];
    }, [groupedOptions, options])?.sort((a, b) => {
        return a.name.localeCompare(b.name);
    });

    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value } }) => (
                <FormControl fullWidth>
                    <FormLabel htmlFor={name}>
                        {label}
                    </FormLabel>

                    <AutoCompleteField
                        viewOnly={props.viewOnly}
                        options={_options}
                        value={value}
                        label={label}
                        onChange={val => {
                            onChange(val);
                            props.onChange?.(val);
                        }}
                        mutation={ADD_BENEFIT_PRO}
                        placeholder={placeholder}
                        disabled={disabled}
                        allowAdd={props.allowAdd}
                        multiple={true}
                        groupBy={groupedOptions ? (option: NestedSubOption) => option?.parent?.name : undefined}
                        newValueResolver={(data: any): NestedSubOption => {
                            return {
                                name: data.name,
                                id: data.name,
                                icon: undefined,
                                parent: { name: 'Autre', id: data.profession?._id || 'other' },
                            };
                        }}
                    />
                </FormControl>
            )}
        />
    );
}
